<div #calendarEmit class="calendars">
    <form [formGroup]="formCalendar">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="calendar-wrapper">
                        <mat-calendar #calendar formControlName="fromCalendar" [maxDate]="selectedDateTo || today"
                            ngDefaultControl (selectedChange)="emitFrom($event)" [(selected)]="selectedDateFrom">
                        </mat-calendar>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="calendar-wrapper">
                        <mat-calendar #calendar1 formControlName="toCalendar" ngDefaultControl
                            (selectedChange)="emitTo($event)" [(selected)]="selectedDateTo"></mat-calendar>
                    </div>
                </div>
            </div>
            <div class="row">
                    <button mat-raised-button class="btnFormSecondary"
                        (click)="directDate('today')">{{ 'TAB_STEPPER.TODAY' | translate }}</button>
                    <button mat-raised-button class="btnFormSecondary"
                        (click)="directDate('yesterday')">{{ 'TAB_STEPPER.YESTERDAY' | translate }}</button>
                    <button mat-raised-button class="btnFormSecondary"
                        (click)="directDate('lastWeek')">{{ 'TAB_STEPPER.LAST_WEEK' | translate }}</button>
                    <button mat-raised-button class="btnFormSecondary"
                        (click)="directDate('lastMonth')">{{ 'TAB_STEPPER.LAST_MONTH' | translate }}</button>
            </div>
        </div>
    </form>
</div>